export const SET_FORECAST_RC_DATA = "SET_FORECAST_RC_DATA"
